import type { WritableSignal } from '@angular/core';
import { InjectionToken } from '@angular/core';
import type { OnyxOverlayConfig } from '../../directives/interfaces';

export const ONYX_DATEPICKER_CONFIG = new InjectionToken<OnyxDatepickerConfig>(
  'Datepicker configuration',
);

export interface OnyxDatepickerConfig extends OnyxOverlayConfig {
  date: WritableSignal<OnyxDate>;
  changeDate: (date: OnyxDate | null) => void;
  disableFocusout: () => void;
  showDateRange: boolean;
  yearsRange: OnyxDatepickerYearsRange;
}

export interface OnyxDate {
  date?: string | null;
  from?: string | null;
  to?: string | null;
  indefinite?: boolean;
}

export interface OnyxDatepickerYearsRange {
  past: number;
  future: number;
}
